import config from '../../config'
import { authHeader } from '../utils/auth-header'

export const fixtureTeamService = {
  deleteMany
}

async function deleteMany (fixtureTeamIds) {
  let requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }

  for (let fixtureTeamId of fixtureTeamIds) {
    await fetch(`${config.apiUrl}/fixtureteam/${fixtureTeamId}`, requestOptions)
  }

  return 'OK'
}



// WEBPACK FOOTER //
// ./src/services/fixtureteam.js